<template lang="pug">
    .md-content
        PmBreadcrumbs(:view="lenguageNavSelected.breadcrumb", :section="section", :lang="lenguage")
        PmBanner(:name="lenguageNavSelected.title", :image="banner")
        PmContentBox(:content="lenguageNavSelected.box")
        .container
            .row
                .col-md-4
                    PmSidebar(:options="lenguageNavSelected.nav", :contact="true", :lang="lenguage")
                .col-md-8
                    transition(name="fade", mode="out-in")
                        router-view 

</template>

<script>
import PmBreadcrumbs from '@components/atoms/PmBreadCrumbs.vue'
import PmBanner from '@components/atoms/PmBanner.vue'
import PmContentBox from '@components/atoms/PmContentBox.vue'
import PmSidebar from '@components/atoms/PmSidebar.vue'

import portfolioBanner from '@img/portfolio/Banner_PORTFOLIO_MANAGEMENT.jpg'

export default {
    props: ["lang"],
    created: function(){
        this.$data.lenguage = this.lang
        console.log(this.lang)  
    },
    components: {
        PmBreadcrumbs, PmBanner, PmContentBox, PmSidebar
    },
    mounted: function(){
        this.$data.section = this.$route.name;
        let to = this.moveToDown
        ? this.$refs.description.offsetTop - 60
        : 0

    window.scroll({
        top: to,
        left: 0,
        behavior: 'smooth'
    })

    this.moveToDown = !this.moveToDown
    },
    data: function(){
        return{
            lenguage: 'EN',
            enContent: {
                nav: [
                    {name:"Property Developers", path: "/en/portfolio/property-developers", isactive: true},
                    {name:"Land Owners", path: "/en/portfolio/property-developers",  isactive: true},
                    {name:"Commercial Real Estate Owners", path: "/en/portfolio/property-developers",  isactive: true},
                    {name:"Large Venues", path: "/en/portfolio/property-developers",  isactive: true},
                    {name:"Infrastructure Owners", path:"/en/portfolio/property-developers",  isactive: true},
                    {name:"Public Service Companies", path:"/en/portfolio/property-developers",  isactive: true},
                    {name:"City and Street Furniture Owners", path:"/en/portfolio/property-developers", isactive: true}
                ],
                box: 'We help network operators meet the connectivity needs of an increasingly mobile-dependent population. As customer demands evolve and expand, we help carriers ensure their customers can stay in touch effectively, wherever they are.',
                title: 'PORTFOLIO MANAGAMENT',
                breadcrumb: {name:'Portfolio', link:'/en/portfolio/property-developers'},
            },
            esContent: {
                nav: [
                    {name:"Desarrolladores de Bienes Raíces", path: "/es/portafolio/desarrolladores-de-bienes-raices", isactive: true},
                    {name:"Propietarios de Predios", path: "/es/portafolio/desarrolladores-de-bienes-raices", isactive: true},
                    {name:"Propietarios de Inmuebles Comerciales", path: "/es/portafolio/desarrolladores-de-bienes-raices", isactive: true},
                    {name:"Propietarios de Inmuebles insignia", path: "/es/portafolio/desarrolladores-de-bienes-raices", isactive: true},
                    {name:"Dueños de Infraestructura", path:"/es/portafolio/desarrolladores-de-bienes-raices", isactive: true},
                    {name:"Organizaciones de Servicios Públicos", path:"/es/portafolio/desarrolladores-de-bienes-raices", isactive: true},
                    {name:"Propietarios de Mobiliario Urbano y de Calle", path:"/es/portfolio/desarrolladores-de-bienes-raices", isactive: true}
                ],
                box: 'Ayudamos a los operadores móviles a cubrir los requerimientos de conectividad derivados de una creciente demanda de usuarios de telefonía móvil, quiénes dependen cada vez más de la conexión móvil. A medida que las necesidades de los usuarios evolucionan y se expanden, ayudamos a los operadores de telefonía celular a preparar sus redes para que sus clientes puedan mantenerse en contacto de manera efectiva, dondequiera que estén.',
                title: 'PORTAFOLIO',
                breadcrumb: {name:'Portafolio', link:'/es/portfolio/desarrolladores-de-bienes-raices'},
            },
            banner: portfolioBanner,
            
            section: ''
        }
    },
    computed: {
        lenguageNavSelected: function(){
            return this.$data.lenguage == 'EN'? this.$data.enContent : this.$data.esContent
        }
    },
}
</script>

<style lang="scss" scoped>

</style>




// WEBPACK FOOTER //
// src/components/organisms/PmPortfolio.vue